<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <vx-card v-else>
      <div>
        <div
          slot="no-body"
          class="tabs-container pt-6 inventory_tabSec"
          id="view-customer-tab"
        >
          <vs-table
            @selected="handleSelected1"
            :max-items="descriptionItems[0]"
            pagination
            :data="productlist"
            description
            search
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div
                style="margin-right: auto; font-size: 1.5rem; font-weight: 550"
              >
                {{ $t("setup.label.Products") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  @click="$router.push({ name: 'Create Product' })"
                  size="small"
                  >{{ $t("setup.label.CreateProduct") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.Code") }}</vs-th>
              <vs-th>{{ $t("setup.label.Description") }}</vs-th>
              <vs-th>{{ $t("setup.label.Service") }}</vs-th>
              <vs-th>{{ $t("setup.label.Status") }}</vs-th>
              <vs-th>{{ $t("setup.label.Bouquet") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="product"
                v-for="(product, index) in data"
              >
                <vs-td :data="product.productCode">{{
                  product.productCode
                }}</vs-td>
                <vs-td :data="product.productDescription">{{
                  product.productDescription
                }}</vs-td>
                <vs-td :data="product.serviceCode">{{
                  product.serviceCode
                }}</vs-td>
                <vs-td :data="product.productStatus">{{
                  product.productStatus
                }}</vs-td>
                <vs-td :data="product.bouquet">{{ product.bouquet }}</vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      :title="$t('setup.label.View')"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="handleSelected1(product)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editProduct(product.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="LinkIcon"
                      :title="$t('setup.label.ProductMapping')"
                      class="icon_row"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                      @click.stop="
                        $router.push(
                          `/setup/broadcaster-channel/editproductmapping/${product.id}`
                        )
                      "
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      class="icon_row"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      @click.stop="
                        delProId = product.id;
                        deleteproductPopup = true;
                      "
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>

      <delete-popup
        :deletePopup="deleteproductPopup"
        :title="$t('setup.label.Product')"
        @deletePressed="deleteproduct()"
        @cancelPressed="deleteproductPopup = false"
      >
      </delete-popup>
    </vx-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      toggleTable: "",
      toggleTeam: true,
      pages1: [
        { name: "Services", active: "active" },
        { name: "Products", active: "inactive" },
      ],
      descriptionItems: [5, 10, 15],
      deleteservicemastersPopup: false,
      delServiceId: "",
      delProId: "",
      deleteproductPopup: false,
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapState({
      productlist: (state) => state.serviceProducts.productlist,
    }),
  },
  methods: {
    handleSelected1(product) {
      this.$router.push({ name: "View Products", params: { id: product.id } });
    },

    async deleteproduct() {
      this.deleteproductPopup = false;
      await this.$store.dispatch(
        "serviceProducts/deleteproductAction",
        this.delProId
      );
      this.$toasted.success("Deleted Successfully", {
        duration: 3000,
      });
      this.getProductList();
    },

    async getProductList() {
      try {
        await this.$store.dispatch("serviceProducts/setProductList");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },

    editProduct(id) {
      this.$router.push({ name: "Edit Product", params: { id: id } });
    },
  },
  mounted() {
    this.toggleTeam = true;
    this.getProductList();
  },
};
</script>
<style scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow: hidden;
  background-color: rgba(var(--vs-primary), 1) !important;
  border-radius: 0.2rem;
}

li {
  float: left;
  font-weight: 550;
  font-size: 0.8rem;
  cursor: pointer;
}

li a {
  display: block;
  color: #fff;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  border: solid 0.2rem rgba(var(--vs-primary), 1);
}

li a:hover:not(.active) {
  border: solid 0.2rem rgba(var(--vs-primary), 1) !important ;
  background-color: #fff;
  color: rgba(var(--vs-primary), 1);
  box-shadow: rgba(var(--vs-primary), 1) 0px 7px 29px 0px;
}

.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  position: absolute;
  top: 1.3rem;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}

.con-vs-tabs .con-ul-tabs,
.vs-tabs--ul {
  position: absolute;
  left: 1rem;
  top: 1.2rem;
}
</style>
